<template>
   <router-link
      data-cy="min-nav-logo"
      :to="{ name: authStore.authTokenExists ? 'home' : 'landing', params: { locale: $route.params?.locale } }"
   >
      <CompanyLogo />
   </router-link>
</template>

<script setup lang="ts">
import { useAuthStore } from "@/stores/authStore";
const authStore = useAuthStore();
</script>
